import { render, staticRenderFns } from "./edit-abroadorder.vue?vue&type=template&id=295722c6&"
import script from "./edit-abroadorder.vue?vue&type=script&lang=ts&"
export * from "./edit-abroadorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports